import { Router } from '@angular/router';
import { GlobalsService } from 'src/app/services/globals.service';
import { BasePageComponent } from '../base-page/base-page.component';

export abstract class BaseTenantRequiredPageComponent extends BasePageComponent {

  constructor(
    hasLoadRights: boolean,
    globalsService: GlobalsService,
    router: Router) {
      super(hasLoadRights, router);

      if (!this.redirecting && !globalsService.getActiveCompany()) {
        router.navigate(["/"]);
        this.redirecting = true;
      }
   }

}